import {
  Box,
  Button,
  Container,
  Typography
} from '@mui/material';

import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

type ScanPurpose = 'Stub Release' | 'Final Release' | 'Exit Poll';

const ScanPurposePage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handlePurposeSelect = (purpose: ScanPurpose) => {
    // Navigate to QR scan page with the selected purpose
    navigate('/scan-voter-qr', { state: { purpose } });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ 
        my: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2,
        textAlign: 'center'
      }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Select Scan Purpose
        </Typography>

        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 2,
          mt: 2 
        }}>
          {user?.permissions?.scan_qr_stub_release && (
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              fullWidth
              onClick={() => handlePurposeSelect('Stub Release')}
            >
              Stub Release
            </Button>
          )}

          {user?.permissions?.scan_qr_final_release && (
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              fullWidth
              onClick={() => handlePurposeSelect('Final Release')}
            >
              Final Release
            </Button>
          )}

          {user?.permissions?.scan_qr_exit_poll && (
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              fullWidth
              onClick={() => handlePurposeSelect('Exit Poll')}
            >
              Exit Poll
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default ScanPurposePage;
